// Node#remove, which IE 11 lacks
export default function removeNode(node) {
  var _node$parentNode;
  node == null || (_node$parentNode = node.parentNode) == null || _node$parentNode.removeChild(node);
}